


































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { ICenter } from '@/store/modules/views/center/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class EditCenterDialog extends VueExtendedBaseComponent {

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get fieldValidate() {
    return this.formInstant.validate()
  }
  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editCenterDialogOption() {
    return {
      justify: 'start',
      form: this.$refs.form && this.openDialog ? this.$refs.form : {},
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editCenterAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get validateInput() {
    return this.nameValidate(this.name)
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private center!: ICenter & {roles: string[], permissions: string[], accounts: string[]}
  private loading = false
  private urlCenter = ''
  @Getter('map/getMapCenterLocation')
  private centerMapData!: { lat: number; lon: number, address: string }

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private activePicker = null
  private valid = false
  private name = ''
  private snackbar = false
  private address = ''
  private map = {
    lat: 0,
    lon: 0,
  }
  private location: ICenter['address'] = {address: ''}

  private async created() {
    this.name = this.center.name || ''
    this.address = this.center.address.address || ''
    this.map = this.center.map
    this.location = this.center.address || {address: ''}
    this.urlCenter = `${process.env.VUE_APP_API_URL}/v1/all/center/${this.center._id}`
  }

  private requireInput(value) {  return value !== '' || 'จำเป็นต้องกรอก' }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('text', this.address, true),
          this.validateInputFromType('number', this.map.lat.toString()),
          this.validateInputFromType('number', this.map.lat.toString()),
        ],
        (item) => item !== true,
    )
  }

  private async editCenterAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const centerData = {
        edit: {
          name: this.name,
          address: {address: this.address, ...this.location},
          map: this.map,
        },
      }
      try {
        await Promise.all([
          HttpRequestServiceWithToken.put(this.urlCenter, centerData.edit),
        ])
        this.updateSnackbar({txt: 'แก้ไขศูนย์บริการสำเร็จ', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
